<template>
  <div id="app">
    <Navigation :name="this.$route.name"/>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>
import Navigation from "@/layouts/Navigation";

const Footer = () => import('@/layouts/Footer');

export default {
  name: 'app',
  components: {
    Navigation,
    Footer
  }
}

</script>

<style lang="scss">
@import 'src/assets/scss/imports';

section {
  padding-bottom: 60px;

  // Margin for first section, because navigation
  &:first-child {
    margin-top: 170px;

    @include media-breakpoint-down(md) {
      margin-top: 150px;
    }

    @include media-breakpoint-down(sm) {
      margin-top: 110px;
    }
  }
}
</style>
